var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHltVCms01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.673828 36.1698V42.541H45.3262V3.45898H0.673828V32.5819",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3262 8.59497H0.673828",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74366 5.95137C3.74362 5.95136 3.74359 5.95136 3.74356 5.95135C3.73906 5.95226 3.73035 5.95448 3.71874 5.95974C3.69609 5.97001 3.67651 5.98548 3.66268 6.00158C3.65323 6.01259 3.64839 6.02118 3.64601 6.02663C3.64841 6.03219 3.65331 6.04099 3.66298 6.05226C3.67695 6.06852 3.69664 6.08404 3.71929 6.0943C3.73064 6.09944 3.73917 6.10165 3.74366 6.10258C3.74369 6.10259 3.74373 6.1026 3.74377 6.1026C3.74827 6.10169 3.75698 6.09947 3.76859 6.09421C3.79124 6.08394 3.81083 6.06846 3.82466 6.05235C3.83412 6.04134 3.83895 6.03276 3.84133 6.0273C3.83894 6.02174 3.83404 6.01296 3.82438 6.00171C3.81042 5.98545 3.79073 5.96992 3.76807 5.95967C3.7567 5.95452 3.74815 5.9523 3.74366 5.95137ZM3.6439 6.03335C3.64397 6.03337 3.6442 6.03263 3.64437 6.03104L3.6439 6.03335ZM3.64438 6.0222C3.64421 6.02061 3.644 6.01986 3.64393 6.01988L3.64438 6.0222ZM3.84345 6.02057C3.84338 6.02055 3.84315 6.0213 3.84298 6.02289L3.84345 6.02057ZM3.84297 6.03174C3.84314 6.03333 3.84336 6.03408 3.84342 6.03406L3.84297 6.03174Z",
    fill: "#457ABD",
    stroke: "#457ABD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15434 5.95137C6.1543 5.95137 6.15426 5.95136 6.15423 5.95135C6.14973 5.95227 6.14102 5.95449 6.12942 5.95974C6.10677 5.97001 6.08719 5.98548 6.07336 6.00158C6.0639 6.01259 6.05907 6.02118 6.05669 6.02663C6.05908 6.03219 6.06399 6.04099 6.07366 6.05226C6.08763 6.06852 6.10732 6.08404 6.12997 6.0943C6.14131 6.09944 6.14985 6.10165 6.15434 6.10258C6.15437 6.10259 6.15441 6.1026 6.15445 6.1026C6.15894 6.10169 6.16765 6.09947 6.17925 6.09421C6.2019 6.08395 6.22148 6.06847 6.23531 6.05237C6.24477 6.04136 6.2496 6.03278 6.25198 6.02732C6.24959 6.02176 6.24468 6.01297 6.23501 6.0017C6.22105 5.98543 6.20136 5.96991 6.1787 5.95966C6.16736 5.95452 6.15883 5.9523 6.15434 5.95137ZM6.05458 6.03335C6.05465 6.03337 6.05487 6.03263 6.05504 6.03104L6.05458 6.03335ZM6.05506 6.0222C6.05489 6.02061 6.05467 6.01986 6.05461 6.01988L6.05506 6.0222ZM6.25409 6.0206C6.25402 6.02058 6.2538 6.02133 6.25363 6.02291L6.25409 6.0206ZM6.25361 6.03176C6.25378 6.03334 6.254 6.03409 6.25407 6.03407L6.25361 6.03176Z",
    fill: "#457ABD",
    stroke: "#457ABD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56498 5.95137C8.56494 5.95137 8.56491 5.95136 8.56487 5.95135C8.56037 5.95227 8.55166 5.95449 8.54005 5.95975C8.5174 5.97001 8.49781 5.98549 8.48397 6.0016C8.47452 6.01261 8.46969 6.0212 8.4673 6.02666C8.4697 6.03221 8.4746 6.04099 8.48426 6.05224C8.49822 6.06851 8.51791 6.08403 8.54057 6.09429C8.55194 6.09944 8.56049 6.10166 8.56498 6.10258C8.56501 6.10259 8.56505 6.1026 8.56508 6.10261C8.56958 6.10169 8.57829 6.09947 8.5899 6.09421C8.61255 6.08395 8.63213 6.06847 8.64596 6.05237C8.65541 6.04136 8.66025 6.03278 8.66263 6.02732C8.66023 6.02176 8.65533 6.01297 8.64565 6.0017C8.63169 5.98543 8.612 5.96991 8.58935 5.95966C8.578 5.95452 8.56947 5.9523 8.56498 5.95137ZM8.46519 6.03338C8.46526 6.0334 8.46548 6.03266 8.46566 6.03107L8.46519 6.03338ZM8.46567 6.02221C8.4655 6.02063 8.46528 6.01988 8.46521 6.0199L8.46567 6.02221ZM8.66473 6.0206C8.66467 6.02058 8.66444 6.02133 8.66427 6.02291L8.66473 6.0206ZM8.66426 6.03176C8.66442 6.03334 8.66464 6.03409 8.66471 6.03407L8.66426 6.03176Z",
    fill: "#457ABD",
    stroke: "#457ABD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3404 21.3309H38.9335C39.7024 21.3309 40.3258 20.7077 40.3258 19.9388C40.3258 19.1699 39.7024 18.5466 38.9335 18.5466H20.3404C19.5715 18.5466 18.9482 19.1699 18.9482 19.9388C18.9482 20.7077 19.5715 21.3309 20.3404 21.3309Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6803 29.4832C12.9114 29.4832 12.2881 30.1065 12.2881 30.8754C12.2881 31.6443 12.9114 32.2676 13.6803 32.2676H38.9337C39.7026 32.2676 40.3258 31.6443 40.3258 30.8754C40.3258 30.1065 39.7026 29.4832 38.9337 29.4832H13.6803Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6484 13.0782H13.6802C12.9114 13.0782 12.2881 13.7014 12.2881 14.4704C12.2881 15.2393 12.9114 15.8625 13.6802 15.8625H38.9336C39.7025 15.8625 40.3258 15.2393 40.3258 14.4704C40.3258 13.7014 39.7025 13.0782 38.9336 13.0782H35.241",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6802 37.6384H38.9336C39.7025 37.6384 40.3257 37.0152 40.3257 36.2462C40.3257 35.4773 39.7025 34.8541 38.9336 34.8541H13.6802C12.9113 34.8541 12.2881 35.4773 12.2881 36.2462C12.2881 37.0152 12.9113 37.6384 13.6802 37.6384Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5485 26.7992H38.9337C39.7026 26.7992 40.3259 26.1759 40.3259 25.407C40.3259 24.6381 39.7026 24.0148 38.9337 24.0148H27.5485C26.7796 24.0148 26.1562 24.6381 26.1562 25.407C26.1562 26.1759 26.7796 26.7992 27.5485 26.7992Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67383 14.6614L6.68008 15.6676L9.26946 13.0781",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3223 20.1297L13.3285 21.136L15.9179 18.5465",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5996 25.5981L20.6059 26.6044L23.1952 24.0149",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67383 31.0664L6.68008 32.0726L9.26946 29.4832",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67383 36.5348L6.68008 37.541L9.26946 34.9515",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHltVCms01);
export default __webpack_public_path__ + "static/media/HLT-vCMS01.1f2ff6b734a735bc3f3f5bd960c6c6a9.svg";
export { ForwardRef as ReactComponent };